export default __webpack_public_path__ + "static/media/EditProfile.762fd74e.svg";